<template>
    <div>
        <v-navigation-drawer :model-value="drawer" :rail="rail" rail-width="58" location="left" color="f9f9f9-171717" class="mx-auto px-2" width="280" border="none">
            <v-list-item>
                <v-row no-gutters align="center" class="mt-4">
                    <div class="mt-1">
                        <div class="pointer text-icon" @click="watchNavigationDrawer(!drawer)" v-if="drawer">
                            <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.35719 3H14.6428C15.7266 2.99999 16.6007 2.99998 17.3086 3.05782C18.0375 3.11737 18.6777 3.24318 19.27 3.54497C20.2108 4.02433 20.9757 4.78924 21.455 5.73005C21.7568 6.32234 21.8826 6.96253 21.9422 7.69138C22 8.39925 22 9.27339 22 10.3572V13.6428C22 14.7266 22 15.6008 21.9422 16.3086C21.8826 17.0375 21.7568 17.6777 21.455 18.27C20.9757 19.2108 20.2108 19.9757 19.27 20.455C18.6777 20.7568 18.0375 20.8826 17.3086 20.9422C16.6008 21 15.7266 21 14.6428 21H9.35717C8.27339 21 7.39925 21 6.69138 20.9422C5.96253 20.8826 5.32234 20.7568 4.73005 20.455C3.78924 19.9757 3.02433 19.2108 2.54497 18.27C2.24318 17.6777 2.11737 17.0375 2.05782 16.3086C1.99998 15.6007 1.99999 14.7266 2 13.6428V10.3572C1.99999 9.27341 1.99998 8.39926 2.05782 7.69138C2.11737 6.96253 2.24318 6.32234 2.54497 5.73005C3.02433 4.78924 3.78924 4.02433 4.73005 3.54497C5.32234 3.24318 5.96253 3.11737 6.69138 3.05782C7.39926 2.99998 8.27341 2.99999 9.35719 3ZM6.85424 5.05118C6.24907 5.10062 5.90138 5.19279 5.63803 5.32698C5.07354 5.6146 4.6146 6.07354 4.32698 6.63803C4.19279 6.90138 4.10062 7.24907 4.05118 7.85424C4.00078 8.47108 4 9.26339 4 10.4V13.6C4 14.7366 4.00078 15.5289 4.05118 16.1458C4.10062 16.7509 4.19279 17.0986 4.32698 17.362C4.6146 17.9265 5.07354 18.3854 5.63803 18.673C5.90138 18.8072 6.24907 18.8994 6.85424 18.9488C7.47108 18.9992 8.26339 19 9.4 19H14.6C15.7366 19 16.5289 18.9992 17.1458 18.9488C17.7509 18.8994 18.0986 18.8072 18.362 18.673C18.9265 18.3854 19.3854 17.9265 19.673 17.362C19.8072 17.0986 19.8994 16.7509 19.9488 16.1458C19.9992 15.5289 20 14.7366 20 13.6V10.4C20 9.26339 19.9992 8.47108 19.9488 7.85424C19.8994 7.24907 19.8072 6.90138 19.673 6.63803C19.3854 6.07354 18.9265 5.6146 18.362 5.32698C18.0986 5.19279 17.7509 5.10062 17.1458 5.05118C16.5289 5.00078 15.7366 5 14.6 5H9.4C8.26339 5 7.47108 5.00078 6.85424 5.05118ZM7 7C7.55229 7 8 7.44772 8 8V16C8 16.5523 7.55229 17 7 17C6.44772 17 6 16.5523 6 16V8C6 7.44772 6.44772 7 7 7Z" fill="currentColor"></path></svg>
                        </div>
                        <div  class="pointer text-icon" @click="watchNavigationDrawer(!drawer)" v-if="!drawer">
                            <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.35719 3H14.6428C15.7266 2.99999 16.6007 2.99998 17.3086 3.05782C18.0375 3.11737 18.6777 3.24318 19.27 3.54497C20.2108 4.02433 20.9757 4.78924 21.455 5.73005C21.7568 6.32234 21.8826 6.96253 21.9422 7.69138C22 8.39925 22 9.27339 22 10.3572V13.6428C22 14.7266 22 15.6008 21.9422 16.3086C21.8826 17.0375 21.7568 17.6777 21.455 18.27C20.9757 19.2108 20.2108 19.9757 19.27 20.455C18.6777 20.7568 18.0375 20.8826 17.3086 20.9422C16.6008 21 15.7266 21 14.6428 21H9.35717C8.27339 21 7.39925 21 6.69138 20.9422C5.96253 20.8826 5.32234 20.7568 4.73005 20.455C3.78924 19.9757 3.02433 19.2108 2.54497 18.27C2.24318 17.6777 2.11737 17.0375 2.05782 16.3086C1.99998 15.6007 1.99999 14.7266 2 13.6428V10.3572C1.99999 9.27341 1.99998 8.39926 2.05782 7.69138C2.11737 6.96253 2.24318 6.32234 2.54497 5.73005C3.02433 4.78924 3.78924 4.02433 4.73005 3.54497C5.32234 3.24318 5.96253 3.11737 6.69138 3.05782C7.39926 2.99998 8.27341 2.99999 9.35719 3ZM6.85424 5.05118C6.24907 5.10062 5.90138 5.19279 5.63803 5.32698C5.07354 5.6146 4.6146 6.07354 4.32698 6.63803C4.19279 6.90138 4.10062 7.24907 4.05118 7.85424C4.00078 8.47108 4 9.26339 4 10.4V13.6C4 14.7366 4.00078 15.5289 4.05118 16.1458C4.10062 16.7509 4.19279 17.0986 4.32698 17.362C4.6146 17.9265 5.07354 18.3854 5.63803 18.673C5.90138 18.8072 6.24907 18.8994 6.85424 18.9488C7.17922 18.9754 7.55292 18.9882 8 18.9943V5.0057C7.55292 5.01184 7.17922 5.02462 6.85424 5.05118ZM10 5V19H14.6C15.7366 19 16.5289 18.9992 17.1458 18.9488C17.7509 18.8994 18.0986 18.8072 18.362 18.673C18.9265 18.3854 19.3854 17.9265 19.673 17.362C19.8072 17.0986 19.8994 16.7509 19.9488 16.1458C19.9992 15.5289 20 14.7366 20 13.6V10.4C20 9.26339 19.9992 8.47108 19.9488 7.85424C19.8994 7.24907 19.8072 6.90138 19.673 6.63803C19.3854 6.07354 18.9265 5.6146 18.362 5.32698C18.0986 5.19279 17.7509 5.10062 17.1458 5.05118C16.5289 5.00078 15.7366 5 14.6 5H10Z" fill="currentColor"></path></svg>
                        </div>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                        <!-- 通知 -->
                        <Notifications class="text-icon" size="22"></Notifications>
                        <!-- 搜索 -->
                        <v-icon size="24" class="pointer text-icon ml-3" @click="watchSearchBar(!searchBar)">mdi:mdi-magnify</v-icon>
                    </div>
                </v-row>
            </v-list-item>
            <v-list class="mt-2">
                <v-list-item>
                    <a href="/unnft/mint" class="del-underline">
                        <v-list-item-title v-if="rail" class="gradient-underline-hover">
                            <v-icon icon="mdi:mdi-image-plus-outline"></v-icon>
                        </v-list-item-title>
                        <Button v-if="!rail" variant="primary"  width="120" rounded="lg" color="black03" aria-label="Create">
                            <v-icon icon="mdi:mdi-image-plus-outline" ></v-icon>
                            <span class="ml-2">Create</span>
                        </Button>
                    </a>
                </v-list-item>
                <v-list-item v-for="(menu, index) in nftMenus" :key="index" :value="index" link>
                    <template v-slot:default="{ isActive }">
                        <router-link :to="menu.to" class="del-underline">
                            <v-list-item-title class="gradient-underline-hover">
                                <v-icon :icon="menu.icon" :class="isActive ? 'text-primary' : 'text-primaryGrey'"></v-icon>
                                <a class="ml-3 gradient-text-hover" :class="isActive ? 'text-primary' : 'text-primaryGrey'">{{ menu.title }}</a>
                            </v-list-item-title>
                        </router-link>
                    </template>
                </v-list-item>
            </v-list>
            <!-- 导航栏底部 -->
            <template v-slot:append>
                <v-list class="mb-4">
                    <v-list-item link>
                        <div @click="avatarMenu = !avatarMenu">
                            <Avatar :menu="avatarMenu" show-name @watchAvatarMenu="watchAvatarMenu"></Avatar>
                        </div>
                        <span v-if="token == null">
                            <router-link :to="'/connectwallet?redirectUrl=' + currentUrl">
                                <v-list-item-title class="gradient-underline-hover">
                                    <v-icon color="icon" icon="mdi mdi-wallet-outline" class="pointer" size="24"></v-icon>
                                    <a class="ml-3 gradient-text-hover text-primaryGrey">Connect Wallet</a>
                                </v-list-item-title>
                            </router-link>
                        </span>
                    </v-list-item>
                </v-list>
                <v-divider></v-divider>
                <!-- <v-list-item>
                    <v-list-item-title>
                        <div class="d-flex align-center mt-1">
                            <a href="https://untrading.org" class="pointer">
                                <Logo type="full_icon_untrading" app="untrading" :color="darkTheme == 1 ? 'dark' : 'light'" size="130"></Logo>
                            </a>
                        </div>
                    </v-list-item-title>
                </v-list-item> -->
                <v-list-item class="mb-8">
                    <v-list-item-title>
                        <div class="d-flex">
                            <!-- 主题 -->
                            <Theme color="icon" size="20"></Theme>
                            <!--举报作弊图标 -->
                            <v-menu v-model="reportCheatingMenu" transition="slide-y-transition" location="top" open-on-hover contained>
                                <template v-slot:activator="{ props }">
                                    <div v-bind="props">
                                        <v-icon color="icon" size="20" class="ml-3" @click="reportCheatingDialog = true">mdi mdi-alert-outline</v-icon>
                                    </div>
                                </template>
                                <v-card class="pa-3 text-primaryGrey" rounded="0">
                                    <h6 class="body-p font-weight-thin text-none">Report Cheating</h6>
                                </v-card>
                            </v-menu>
                            <!-- 安装 -->
                            <Installation color="icon" size="20" class="ml-3"></Installation>
                        </div>
                    </v-list-item-title>
                </v-list-item>
            </template>
        </v-navigation-drawer>
        <!-- 举报作弊弹窗 -->
        <ReportCheating :show="reportCheatingDialog" @watchReportCheatingDialog="watchReportCheatingDialog"></ReportCheating>
    </div>
</template>
<script>
import Logo from '@/components/common/Logo';
import Installation from '@/components/common/Installation';
import ReportCheating from '@/components/common/ReportCheating';
import Theme from '@/components/common/Theme';
import Notifications from '@/components/common/Notifications';
import Avatar from '@/components/user/Avatar';
import { mapGetters } from "vuex";
export default {
    props: {
        drawer: {
            type: Boolean,
            default: false
        },
        searchBar: {
            type: Boolean,
            default: false
        },
    },
    data(){
        return {
            // 是否窄栏
            rail: false,
            // Discord 菜单
            discordMenu: false,
            // 举报作弊菜单
            reportCheatingMenu: false,
            // 举报作弊弹窗
            reportCheatingDialog: false,
            // 头像菜单
            avatarMenu: false,
            // 当前地址
            currentUrl: window.location.href,
            // NFT 菜单
            nftMenus: [
                { title: 'Discover', icon: 'mdi:mdi-bullseye', to: '/unnfts' },
                { title: 'Explore', icon: 'mdi:mdi-compass', to: '/market' },
                { title: 'Curated', icon: 'mdi:mdi-star', to: '/sets' },
                { title: 'Collections', icon: 'mdi:mdi-image-filter-black-white', to: '/collections' },
                { title: 'Import unNFT', icon: 'mdi:mdi-image-check-outline', to: '/unnft/import' },
                { title: 'Wrap NFT', icon: 'mdi:mdi-image-refresh-outline', to: '/unnft/wrap' },
                { title: 'Create Set', icon: 'mdi:mdi-image-multiple-outline', to: '/set/create' },
                { title: 'Create Collection', icon: 'mdi:mdi-file-multiple-outline', to: '/collection/create' },
            ],
        }
    },
    components: { Logo, Installation, ReportCheating, Theme, Notifications, Avatar },
    created(){

    },
    mounted(){

    },
    computed: {
        ...mapGetters(['token', 'darkTheme','responsive'])
    },
    watch:{
        $route: {
            handler(n, o) {
                this.currentUrl = window.location.href;
            },
            immediate: true
        },
    },
    methods: {
        watchReportCheatingDialog(show) {
            this.reportCheatingDialog = show;
        },
        // 监听导航栏显示状态
        watchNavigationDrawer(show) {
            this.$emit('watchNavigationDrawer', show);
        },
        // 监听搜索栏显示状态
        watchSearchBar(show) {
            this.$emit('watchSearchBar', show);
        },
        // 监听头像菜单
        watchAvatarMenu(show) {
            this.avatarMenu = show;
        },
    }
}
</script>
<style scoped>
/* 条目激活时显示主题色 */
/* .v-list-item--active {
    background: rgb(var(--v-theme-primary)) !important;
    color: rgb(var(--v-theme-primary)) !important;
} */
</style>